module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/examples/search-tests/search-tests.component.scss
// module id = ./src/app/components/examples/search-tests/search-tests.component.scss
// module chunks = main